export interface Language {
  [key: string]: string;
}

export const interfaceEN: Language = {
  MAIN_TITLE: "Capital Quiz 3.0",
  OPTIONS: "Options",
  IRON_MAN_MODE: "Iron Man Mode",
  IRON_MAN_MODE_DESC: "One wrong answer and you lose. 50/50 doesn't work.",
  NORMAL_QUIZ: "Start Quiz",
  CHANGE_LANGUAGE: "Русский Язык",
  I_WANT_TO_KNOW: "I want to know",
  NUMBER_OF_QUESTIONS: "Number of questions",
  FLIP: "Flip the question",
  FLIP_DESC:
    "Now you know the capital. But what about the country? Works for region and flags too.",
  SHOW5050: "Show 50/50",
  BUTTON_5050: "50/50",
  SHOW5050_DESC: "Let us give you a little help. 2 answers instead of 4.",
  HIDE_LETTERS: "Hide letters",
  HIDE_LETTERS_DESC:
    "Some like it hot. You see only the first and the last letter.",
  START_QUIZ: "Start Quiz",
  RIGHT: "Right",
  WRONG: "Wrong",
  OUT_OF: "out of",
  BACK_TO_START: "Back to Start",
  PLAY_AGAIN: "Play Again",
  LONGEST_STREAK_001: "Your longest Iron Man Mode win streak is ",
  LONGEST_STREAK_002: " questions.",
  QUESTIONS_CORRECT: "questions correct.",
  CLEAR_STREAK: "Clear Streak",
  QUESTION_TEXT: "Choose the capital of this country:",
  QUESTION_REGION_TEXT: "Choose the region of this country:",
  QUESTION_TEXT_FLIP: "Choose the country of this capital:",
  QUESTION_REGION_TEXT_FLIP: "Choose the country in this region:",
  STATISTICS: "Statistics",
  All_TIME_RIGHT_ANSWERS: "All time right answers:",
  All_TIME_WRONG_ANSWERS: "All time wrong answers:",
  RIGHT_ANSWERS_ON_AVERAGE: "Right answers on average, %",
  LONGEST_IRON_MAN: "Longest Iron Man win streak: ",
  OPTION5050_USED: "50/50 used:",
  GAMES_FINISHED: "All games finished:",
  IRON_MAN_ATTEMPTS: "Iron Man attempts:",
  REGION: "Change capital to region",
  REGION_DESC: "Choose a region of a country instead of a capital.",
  IRON_MAN_FINISHED: "Iron Man games finished:",
  CLEAR_STATISTICS: "Clear statistics",
  FLAGS: "Flag Game",
  FLAGS_DESC: "Flag of the country instead of a capital.",
  QUESTION_FLAGS_TEXT: "Choose the flag of this country:",
  QUESTION_FLAGS_TEXT_FLIP: "Choose the country of this flag:",
  SEARCH: "Search",
  SEARCH_DESC: "Type a country or a capital in English"
};

export const interfaceRU: Language = {
  MAIN_TITLE: "Капитальный 3.0",
  OPTIONS: "Настройки",
  IRON_MAN_MODE: "Железный Человек",
  IRON_MAN_MODE_DESC: "Одна ошибка и проигрыш. 50/50 не работает.",
  NORMAL_QUIZ: "Начать Квиз",
  CHANGE_LANGUAGE: "English",
  I_WANT_TO_KNOW: "Хочу узнать",
  NUMBER_OF_QUESTIONS: "Количество вопросов",
  FLIP: "Наоборот",
  FLIP_DESC:
    "Столица известна, отгадайте страну. Также работает с регионом и флагами.",
  SHOW5050: "Показать 50/50",
  BUTTON_5050: "50/50",
  SHOW5050_DESC: "Немного помощи не помешает. 2 ответа вместо 4-х.",
  HIDE_LETTERS: "Спрятать буквы",
  HIDE_LETTERS_DESC:
    "Для любителей трудностей. Видны только первая и последняя буквы ответа.",
  START_QUIZ: "Начать Квиз",
  RIGHT: "Верно",
  WRONG: "Неверно",
  OUT_OF: "из",
  BACK_TO_START: "Назад",
  PLAY_AGAIN: "Ещё раз",
  LONGEST_STREAK_001: "Ваше наибольшее количество верных ответов: ",
  LONGEST_STREAK_002: ".",
  QUESTIONS_CORRECT: "правильно.",
  CLEAR_STREAK: "Очистить запись",
  QUESTION_TEXT: "Выберите столицу этой страны:",
  QUESTION_REGION_TEXT: "Выберите регион этой страны:",
  QUESTION_TEXT_FLIP: "Выберите страну этой столицы:",
  QUESTION_REGION_TEXT_FLIP: "Выберите страну в этом регионе:",
  STATISTICS: "Статистика",
  All_TIME_RIGHT_ANSWERS: "Верных ответов за всё время:",
  All_TIME_WRONG_ANSWERS: "Неверных ответов за всё время:",
  RIGHT_ANSWERS_ON_AVERAGE: "Верных ответов в среднем, %",
  LONGEST_IRON_MAN: "Лучший результат ЖЧ: ",
  OPTION5050_USED: "50/50 использовано:",
  GAMES_FINISHED: "Всего игр закончено:",
  IRON_MAN_ATTEMPTS: "Количество ЖЧ попыток:",
  REGION: "Регион вместо столицы",
  REGION_DESC: "Отгадайте регион страны вместо столицы.",
  IRON_MAN_FINISHED: "ЖЧ игр закончено:",
  CLEAR_STATISTICS: "Очистить",
  FLAGS: "Флаги стран",
  FLAGS_DESC: "Флаг страны вместо столицы.",
  QUESTION_FLAGS_TEXT: "Выберите флаг этой страны:",
  QUESTION_FLAGS_TEXT_FLIP: "Выберите страну для этого флага:",
  SEARCH: "Поиск",
  SEARCH_DESC: "Напишите название или столицу страны на английском"
};
